$(document).ready(function() {
    countdownClock.init('.tag-countdown');
});
